type Listener = () => void;

type VisitState = {
  active: boolean;
  settled: boolean;
};

const listeners = new Set<Listener>();

const quotesVisit: VisitState = { active: false, settled: false };
const ordersVisit: VisitState = { active: false, settled: false };

function notify() {
  listeners.forEach((listener) => listener());
}

export function subscribeListPageLoading(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function beginQuotesListVisit() {
  quotesVisit.active = true;
  quotesVisit.settled = false;
  notify();
}

export function beginOrdersListVisit() {
  ordersVisit.active = true;
  ordersVisit.settled = false;
  notify();
}

export function settleQuotesListVisit() {
  quotesVisit.settled = true;
  notify();
}

export function settleOrdersListVisit() {
  ordersVisit.settled = true;
  notify();
}

export function clearQuotesListVisit() {
  quotesVisit.active = false;
  quotesVisit.settled = false;
  notify();
}

export function clearOrdersListVisit() {
  ordersVisit.active = false;
  ordersVisit.settled = false;
  notify();
}

export function shouldShowQuotesListLoading() {
  return quotesVisit.active && !quotesVisit.settled;
}

export function shouldShowOrdersListLoading() {
  return ordersVisit.active && !ordersVisit.settled;
}

export function isQuotesListApiUrl(url: string) {
  return typeof url === 'string' && url.includes('/quotes/get');
}

export function isOrdersListApiUrl(url: string) {
  return typeof url === 'string' && url.includes('/order/get');
}
